import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { css } from 'styled-components';
import { viewports, convertUnitToInt } from '../helper';
import { useMediaQuery } from '../hooks';
import { breakpointXs, breakpointSm, breakpointMd, breakpointLg, breakpointXl, sizeSpacing04, sizeSpacing05, sizeSpacing06, sizeSpacing08 } from '@resultadosdigitais/tangram-design-tokens';

function makeMedia(media) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (!args) return;

    if (!media) {
      return css(...args);
    }

    return css(["@media ", "{", "}"], media, css(...args));
  };
}

const arrViewports = Object.values(viewports);
export const renderMediaQueries = function (render) {
  let viewports = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : arrViewports;
  return viewports.map(dimension => config.media[dimension](_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), render(dimension)));
};
export const resolveAlignItems = align => {
  if (!align) return;

  if (typeof align === 'object') {
    return renderMediaQueries(dimension => align[dimension] && css(["align-items:", ";"], align[dimension]));
  }

  return css(["align-items:", ";"], align);
};
export const resolveJustifyContent = justify => {
  if (!justify) return;

  if (typeof justify === 'object') {
    return renderMediaQueries(dimension => justify[dimension] && css(["justify-content:", ";"], justify[dimension]));
  }

  return css(["justify-content:", ";"], justify);
};
const base = {
  columns: {
    smallMobile: 12,
    mobile: 12,
    tablet: 12,
    desktop: 12,
    largeDesktop: 12
  },
  gutterWidth: {
    smallMobile: sizeSpacing04,
    // 16px
    mobile: sizeSpacing04,
    tablet: sizeSpacing05,
    // 24px
    desktop: sizeSpacing05,
    largeDesktop: sizeSpacing05
  },
  paddingWidth: {
    smallMobile: sizeSpacing04,
    // 16px
    mobile: sizeSpacing06,
    // 32px
    tablet: sizeSpacing08,
    // 48px
    desktop: sizeSpacing08,
    largeDesktop: sizeSpacing08
  },
  container: {
    smallMobile: 'full',
    // 'full' = max-width: 100%
    mobile: 'full',
    // 'full' = max-width: 100%
    tablet: 'full',
    // 'full' = max-width: 100%
    desktop: breakpointLg,
    // max-width: 1280px
    largeDesktop: breakpointXl // max-width: 1440px

  },
  breakpoints: {
    smallMobile: 0,
    mobile: breakpointXs,
    // 480px
    tablet: breakpointSm,
    // 768px
    desktop: breakpointMd,
    // 1024x
    largeDesktop: breakpointLg // 1280px

  }
};
const media = Object.keys(base.breakpoints).reduce((media, breakpoint) => {
  const breakpointWidth = base.breakpoints[breakpoint];
  const mediaBP = media;
  mediaBP[breakpoint] = makeMedia(breakpointWidth && "(min-width: ".concat(breakpointWidth, ")"));
  return mediaBP;
}, {});
const mediaQuery = Object.entries(base.breakpoints).reduce((acc, current, index, source) => {
  const width = [];
  const [breakpoint, value] = current;
  const next = source[index + 1];

  if (value) {
    width.push("(min-width: ".concat(value, ")"));
  }

  if (next) {
    const [, nextValue] = next;
    nextValue && width.push("(max-width: ".concat(convertUnitToInt(nextValue) - 1, "px)"));
  }

  const media = width.join(' and ');
  return Object.assign({}, acc, {
    [breakpoint]: "@media ".concat(media)
  });
}, {});
/**
 * Return the match of mediaQuery in use
 * @return {string} Breakpoint names
 */

export const useViewport = () => {
  let viewport;

  for (let key in mediaQuery) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    if (useMediaQuery(mediaQuery[key])) {
      viewport = key;
    }
  }

  return viewport;
};
const config = Object.assign({}, base, {
  media,
  mediaQuery
});
export default config;